// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b4679324","230":"9804eda8","453":"03346f77","457":"850f3002","551":"b0ffe9f2","643":"77ee22a0","672":"477a6254","842":"01821987","851":"3f0086ba"}[chunkId] + ".chunk.js";
};